import styled from "styled-components";

const media = {
  phone: "@media only screen and (max-width:480px)",
  phoneAndTablet: "@media only screen and (max-width:768px)",
  tablet: "@media only screen and (min-width:481px) and (max-width:768px)",
  bigTablet: "@media only screen and (min-width:769px) and (max-width:1024px)",
  comp: "@media only screen and (min-width:1025px)",
};

export const Template = styled.div`
  background: ${(props) => (props.background ? props.background : "#3a3c3f")};

  ${media.phone} {
    width: 90%;
    margin-right: 5%;
  }
`;
// to check if use
export const TableLine = styled.div`
  width: 100%;
  padding: 5px 5px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  font-size: 16px;
  ${media.phoneAndTablet} {
    font-size: 14px;
  }
  ${media.bigTablet} {
    font-size: 14px;
  }
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  transition: 0.2s;
  background-color: ${(props) => (props.background ? props.background : null)};
  :hover {
    transition: 0.2s;
    /* background-color: rgba(192, 192, 192, 0.3); */
  }
`;

export const MyHr = styled.hr`
  background-color: rgba(0, 0, 0, 0.5);
  color: rgba(0, 0, 0, 0.5);
  height: 1px;
  width: 90%;
  margin: 0 auto;
`;

export const RespFont = styled.div`
  font-size: ${(props) =>
    props.csize ? props.csize : "16px"}; // computer size
  ${media.phoneAndTablet} {
    font-size: ${(props) => (props.psize ? props.psize : "14px")}; // phone size
  }
`;

export const TableCard = styled.div`
  border: none;
  border-radius: 10px;
  box-shadow: 0 1px 18px silver;
  width: 20%;
  margin-right: 2.5%;
  margin-left: 2.5%;
  margin-top: 12px;
  ${media.bigTablet} {
    width: 28.3%;
    margin-right: 2.5%;
    margin-left: 2.5%;
  }
  ${media.tablet} {
    width: 45%;
    margin-right: 2.5%;
    margin-left: 2.5%;
  }
  ${media.phone} {
    width: 85%;
    margin-right: 12%;
    margin-left: 3%;
  }
  height: 210px;
  text-decoration: none;
  color: black;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  cursor: pointer;
  transition: 200ms;
  background: rgba(255, 255, 255, 0.9);
  &:hover {
    transform: scale(1.03, 1.03);
    transition: 200ms;
  }
`;

export const TableDayalCard = styled.div`
  border: none;
  border-radius: 5px;
  box-shadow: 0 1px 18px silver;
  width: max-content;
  font-weight: 600;
  /* width: 15%; */
  /* margin-right: 2.5%; */
  /* margin-left: 2.5%; */
  margin: 0 15px;
  padding: 0 10px;
  margin-top: 12px;
  /* ${media.bigTablet} {
    width: 20%;
    margin-right: 2.5%;
    margin-left: 2.5%;
  }
  ${media.tablet} {
    width: 28.3%;
    margin-right: 2.5%;
    margin-left: 2.5%;
  }
  ${media.phone} {
    width: 33%;
    margin-right: 2%;
    margin-left: 3%;
  } */
  text-decoration: none;
  color: black;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: auto;
  cursor: pointer;
  transition: 200ms;
  background: rgba(255, 255, 255, 0.9);
  &:hover {
    transform: scale(1.03, 1.03);
    transition: 200ms;
  }
`;

export const BoldFont = styled(RespFont)`
  font-family: hebB;
`;

export const MediumFont = styled(RespFont)`
  font-family: hebM;
`;

export const Label = styled(MediumFont)`
  margin-bottom: 5px;
  text-align: right;
`;

export const Input = styled.input`
  padding: 10px 0px;
  padding-right: 5px;
  width: 100%;
  border-radius: 5px;
  transition: 0.1s;
  outline: none !important;
  border: none;
  font-size: 16px;
  font-family: inherit;
  background: white;
  &::placeholder {
    color: "#868788";
  }
  ${media.phoneAndTablet} {
    font-size: 14px;
  }
`;

export const TextArea = styled.textarea`
  padding: 10px 0px;
  padding-right: 5px;
  width: 100%;
  border-radius: 5px;
  transition: 0.1s;
  outline: none !important;
  border: none;
  font-size: 16px;
  background: white;
  font-family: inherit;
  &::placeholder {
    color: "#868788";
  }
  ${media.phoneAndTablet} {
    font-size: 14px;
  }
`;

export const ModalStyle = styled.div`
  display: flex;
  overflow: auto;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  min-height: 100vh;
  height: 100%;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  top: 0px;
  left: 0px;
  z-index: 3;
  background: radial-gradient(
    circle,
    #f2f2f2 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
  backdrop-filter: blur(4px);
`;

export const ModalStyleRight = styled.div`
  display: flex;
  overflow: auto;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  min-height: 100vh;
  height: 100%;
  flex-direction: row;
  text-align: center;
  justify-content: flex-start;
  align-items: center;
  top: 0px;
  left: 0px;
  z-index: 3;
`;

export const PlaceHolderImage = styled.img`
  position: absolute;
  left: 0px;
  top: ${(props) => (props.top ? props.top : "50%")};
  width: ${(props) => (props.fontSize ? props.fontSize : "50%")};
  transform: translate(0, -50%);
`;

export const PopupForm = styled.form`
  width: ${(props) => (props.cWidth ? props.cWidth : "30%")};
  ${media.phoneAndTablet} {
    width: ${(props) => (props.pWidth ? props.pWidth : "80%")};
  }
  border-radius: 5px;
  overflow: auto;
  box-shadow: 5px 20px 50px silver;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f2f2f2;
  z-index: 2;
  transition: all 0.2s !important;
`;

export const PopupDiv = styled.div`
  width: ${(props) => (props.cWidth ? props.cWidth : "30%")};
  ${media.phoneAndTablet} {
    width: ${(props) => (props.pWidth ? props.pWidth : "80%")};
  }
  border-radius: 5px;
  overflow: auto;
  box-shadow: 5px 20px 50px silver;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: #f2f2f2;
  z-index: 2;
  transition: all 0.2s !important;
`;

export const DropOption = styled.div`
  background: ${(props) => (props.background ? props.background : "white")};
  cursor: pointer;
  padding: 2px 5px;
  margin: 0 1.5px;
  border-radius: 2px;
  box-shadow: 0 2px 4px ${(props) => (props.shadow ? props.shadow : "silver")};
`;

export const Button = styled.button`
  text-decoration: none;
  font-size: 16px;
  ${media.phoneAndTablet} {
    font-size: 14px;
  }
  border-radius: 5px;
  font-family: hebM;
  cursor: pointer;
  user-select: none;
  border: none;
  min-width: max-content;
  background: ${(props) =>
    props.background
      ? props.background
      : "linear-gradient(90deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%)"};
  box-shadow: 0px 2px 4px silver;
  color: ${(props) => (props.color ? props.color : "#ffffff")};
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  outline: none;
  &:hover {
    transition: all 0.2s;
    background: ${(props) =>
      props.hoverBackground
        ? props.hoverBackground
        : "rgb(218, 216, 216)"} !important;
    color: ${(props) =>
      props.hoverColor ? props.hoverColor : "#3A3C3F"} !important;
    box-shadow: 2px 2px 8px gray;
  }
`;

export const FlexRowBetween = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
`;

export const FlexRowBetweenReverse = styled.div`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
`;

export const FlexColumnBetween = styled(FlexRowBetween)`
  flex-direction: column;
`;

export const FlexRowColumnBetweenReverse = styled(FlexRowBetweenReverse)`
  ${media.phoneAndTablet} {
    flex-direction: column;
  }
`;

export const FlexRowColumnBetween = styled(FlexRowBetween)`
  ${media.phoneAndTablet} {
    flex-direction: column;
  }
`;

export const FlexRowStart = styled(FlexRowBetween)`
  justify-content: flex-start;
  flex-wrap: wrap;
`;

export const TodoCard = styled.div`
  border: none;
  position: relative;
  border-left: ${(props) =>
    props.borderL ? `5px solid ${props.borderL}` : "none"};
  border-radius: 5px;
  width: 23%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 0;
  margin-right: 1.6%;
  margin-top: 12px;
  ${media.bigTablet} {
    width: 30%;
    margin-right: 2.5%;
  }
  ${media.tablet} {
    width: 45%;
    margin-right: 3.3%;
  }
  ${media.phone} {
    width: 90%;
    margin-right: 5%;
  }
  overflow: auto;
  cursor: pointer;
  padding: 20px 10px;
  transition: 200ms;
  background: #f2f2f2;
  height: min-content;
  &:hover {
    transform: scale(1.03, 1.03);
    transition: 200ms;
  }
`;

export const GuestCard = styled.div`
  /* border: none; */
  border-left: ${(props) =>
    props.borderLeft ? `5px solid ${props.borderLeft}` : "none"};
  border-radius: 3px;
  width: ${(props) => props.style?.width || "23%"};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 0;
  margin-right: ${(props) => props.style?.marginRight || "1.6%"};
  margin-top: 12px;
  ${media.bigTablet} {
    width: ${(props) => props.style?.width || "30%"};
    margin-right: 2.5%;
  }
  ${media.tablet} {
    width: 45%;
    margin-right: 3.3%;
  }
  ${media.phone} {
    width: 45%;
    margin-right: 3.3%;
  }
  overflow: auto;
  cursor: pointer;
  padding: 10px 10px;
  transition: 200ms;
  background: ${(props) => (props.background ? props.background : "#f2f2f2")};
  height: min-content;
  &:hover {
    transform: scale(1.03, 1.03);
    transition: 200ms;
  }
`;

export const UserCard = styled.div`
  border-left: ${(props) =>
    props.border ? `5px solid ${props.border}` : "none"};
  border-right: ${(props) =>
    props.borderR ? `5px solid ${props.borderR}` : "none"};
  border-radius: 3px;
  width: 30%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 0;
  margin-right: 2.5%;
  margin-top: 12px;
  ${media.tablet} {
    width: 45%;
    margin-right: 3.3%;
  }
  ${media.phone} {
    width: 90%;
    margin-right: 5%;
  }
  overflow: auto;
  cursor: pointer;
  padding: 10px 10px;
  transition: 200ms;
  background: ${(props) => (props.background ? props.background : "#f2f2f2")};
  height: min-content;
  &:hover {
    transform: scale(1.03, 1.03);
    transition: 200ms;
  }
`;

export const ListHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0px 0px;
  overflow: auto;
  padding-bottom: 30px;
`;

export const TextWithPic = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: min-content;
  padding: 10px 20px;
  ${media.phone} {
    padding: 7px 14px;
  }
  border-radius: 3px;
  box-shadow: 0 2px 4px silver;
  background-color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
`;

export const GenericDiv = styled(RespFont)`
  text-decoration: none;
  border-radius: 5px;
  user-select: none;
  border: none;
  min-width: max-content;
  background: ${(props) =>
    props.background
      ? props.background
      : "linear-gradient(to right, rgba(41,59,90,0.95), rgba(123,150,196,0.95))"};
  color: #fff;
  padding: 5px 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 200ms;
`;

export const InvDiv = styled.div`
  max-width: 480px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
  background: ${(props) =>
    `linear-gradient(to bottom, ${props.gradient[0]}, ${props.gradient[1]})`};
`;
